export enum BasketPaymentType {
  PAYPAL = 'Paypal',
  SIMPLEPAY = 'SimplePay',
  CASH = 'Cash',
  TRANSFER = 'Transfer',
  SOFORT = 'Sofort',
  OTP_SZEPKARTYA = 'otp_szepkartya',
  TRANSFER_SZEPKARTYA = 'kh_szepkartya_utalas'
}
